import React from "react";

const Unauthorized = () => {
  return (
    <div className="login-form">
      <div className="centred login-box">
        <i className="white icon-logo" />
        <hr />
        <div>
          <p>You don't have access to this app</p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
